import { apiSlice } from 'store/slices/api/api-slice';
import {
    CardsSphereListRequest,
    CardsSphereListResponse,
    CardsSphereTitleData,
} from 'types/card/card-sphere-list';

export const cardSphereList = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        sphereList: builder.query<
            CardsSphereListResponse,
            CardsSphereListRequest
        >({
            query: (params: CardsSphereListRequest) => ({
                url: '/sphere/card-sphere-list',
                method: 'GET',
                params: params,
            }),
        }),

        sphereTitleList: builder.query<CardsSphereTitleData[], void>({
            query: () => ({
                url: '/sphere/sphere-title-list',
                method: 'GET',
            }),
        }),
    }),
});

export const { useLazySphereListQuery, useSphereTitleListQuery } =
    cardSphereList;
